t = require('views/internal/teacup-with-helpers')('popover_change_board_org')

module.exports = t.renderable ({ orgs, select, allowsSelfJoin, isPrivate }) ->
  t.form ->
    t.label ->
      t.format 'organization'
    t.select '.js-org', ->
      t.optionSelected !orgs, { value: '' }, ->
        t.format 'none'
      for org in orgs
        t.optionSelected select, { value: org.id }, ->
          t.text org.displayName
    if isPrivate
      t.div '.check-div.js-check-div', ->
        t.label ->
          t.input '.js-make-org-visible', { type: 'checkbox', checked: 'checked' }
          t.format 'make-board-visible-to-organization'
    if !allowsSelfJoin
      t.div '.check-div.js-check-div', ->
        t.label ->
          t.input '.js-make-org-joinable', { type: 'checkbox', checked: 'checked' }
          t.format 'allow-any-org-member-to-join-this-board'

    t.input '.js-submit.wide.primary', { type: 'submit', value: t.l('add') }

    t.a { href: '#', class: 'js-new-org right-of-button-link' }, ->
      t.format 'create-team'


// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_add_board_to_org.coffee